

export const AUTH_ENDPOINT = '/auth/oauth'
export const AUTH_WINDOW_NAME = 'OAuth';
export const AUTH_TIMEOUT_MS = 120000; // 2 minutes in milliseconds
export const AUTH_WINDOW_FEATURES = 'width=500,height=600';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const OAUTH_SERVICES = {
    GOOGLE: 'google',
    MICROSOFT: 'microsoft',
    USERNAME_PASSWORD: 'username_password'
}
